import { useState } from 'react';

type SegmentedControlProps = {
    segments: string[];
    segmentsSpan?: string[];
    segmentsImage?: any;
    selectedSegmentIndex?: number;
    onSegmentChanged?: (segment: number) => void;
    additionalClasses?: string;
};
export default function SegmentedControlLarge({
    segments,
    segmentsSpan = [],
    segmentsImage = [] as any,
    selectedSegmentIndex = 0,
    additionalClasses = '',
    onSegmentChanged = (index) => {},
}: SegmentedControlProps) {
    const [selectedIndex, setSelectedIndex] = useState(selectedSegmentIndex);
    const handleClick = (index: number) => {
        setSelectedIndex(index);
        onSegmentChanged(index);
    };
    return (
        <div
            className={
                additionalClasses + ' ' + 'segmented-control segmented-control-' + segments.length
            }
            style={{ maxWidth: '100%'}}
        >
            {segments.map((segment, index) => (
                <div
                    className={
                        index == selectedIndex
                            ? 'segmented-control-segment active'
                            : 'segmented-control-segment'
                    }
                    onClick={handleClick.bind(null, index)}
                    key={index}
                >
                    {segment}
                    {!!segmentsImage[index] && (
                        <div className="segment-image">
                            <img
                                className="inactive"
                                src={`/images/${segmentsImage[index].inactive}`}
                                alt="icon"
                            />
                            <img
                                className="active"
                                src={`/images/${segmentsImage[index].active}`}
                                alt="icon"
                            />
                        </div>
                    )}
                    {!!segmentsSpan[index] && <span>{segmentsSpan[index]}</span>}
                </div>
            ))}
        </div>
    );
}
